import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import {
    TabHandleProps,
    SlideOutWrapperProps,
    OverlayProps,
} from './SlideOutTab.types';

export const BOUNCE_MS = 460; // your spring/bump out
export const PAUSE_MS = 1050; // <-- the “slight pause”
export const RETURN_MS = 240; // smooth glide back
const PEEK = 30; // how far the bumpOut peeks out

/* --- StaticTab bounce (left/right, middle variant shown) --- */
export const springOutLeft = keyframes`
  0%   { transform: translateY(-50%) translate3d(0,0,0);                 animation-timing-function: cubic-bezier(.2,.8,.2,1); }
  60%  { transform: translateY(-50%) translate3d(${
      PEEK * 1.2 - 1
  }px,0,0);              animation-timing-function: cubic-bezier(.2,.7,.2,1); }
  78%  { transform: translateY(-50%) translate3d(${
      PEEK * 0.8 - 1
  }px,0,0);              animation-timing-function: cubic-bezier(.2,.65,.2,1); }
  88%  { transform: translateY(-50%) translate3d(${PEEK * 1.1 - 1}px,0,0); }
  100% { transform: translateY(-50%) translate3d(${PEEK - 1}px,0,0); }
`;
export const springOutRight = keyframes`
  0%   { transform: translateY(-50%) translate3d(0,0,0);             animation-timing-function: cubic-bezier(.2,.8,.2,1); }
  60%  { transform: translateY(-50%) translate3d(-${
      PEEK * 1.2 - 1
  }px,0,0);             animation-timing-function: cubic-bezier(.2,.7,.2,1); }
  78%  { transform: translateY(-50%) translate3d(-${
      PEEK * 0.8 - 1
  }px,0,0);             animation-timing-function: cubic-bezier(.2,.65,.2,1); }
  88%  { transform: translateY(-50%) translate3d(-${PEEK * 1.1 - 1}px,0,0); }
  100% { transform: translateY(-50%) translate3d(-${PEEK - 1}px,0,0); }
`;

/* top/bottom (no translateY) versions if you need them */
export const springOutLeftFlat = keyframes`
  0%   { transform: translate3d(0,0,0);                                  animation-timing-function: cubic-bezier(.2,.8,.2,1); }
  60%  { transform: translate3d(${
      PEEK * 1.2 - 1
  }px,0,0);                                animation-timing-function: cubic-bezier(.2,.7,.2,1); }
  78%  { transform: translate3d(${
      PEEK * 0.8 - 1
  }px,0,0);                                animation-timing-function: cubic-bezier(.2,.65,.2,1); }
  88%  { transform: translate3d(${PEEK * 1.1 - 1}px,0,0); }
  100% { transform: translate3d(${PEEK - 1}px,0,0); }
`;
export const springOutRightFlat = keyframes`
  0%   { transform: translate3d(0,0,0);                                  animation-timing-function: cubic-bezier(.2,.8,.2,1); }
  60%  { transform: translate3d(-${
      PEEK * 1.2 - 1
  }px,0,0);                               animation-timing-function: cubic-bezier(.2,.7,.2,1); }
  78%  { transform: translate3d(-${
      PEEK * 0.8 - 1
  }px,0,0);                               animation-timing-function: cubic-bezier(.2,.65,.2,1); }
  88%  { transform: translate3d(-${PEEK * 1.1 - 1}px,0,0); }
  100% { transform: translate3d(-${PEEK - 1}px,0,0); }
`;

/* StaticTab return (back to 0) */
export const tabReturnLeftMid = keyframes`
  from { transform: translateY(-50%) translate3d(${PEEK - 1}px, 0, 0); }
  to   { transform: translateY(-50%) translate3d(0, 0, 0); }
`;
export const tabReturnRightMid = keyframes`
  from { transform: translateY(-50%) translate3d(-${PEEK - 1}px, 0, 0); }
  to   { transform: translateY(-50%) translate3d(0, 0, 0); }
`;
export const tabReturnLeftFlat = keyframes`
    from { transform: translate3d(${PEEK - 1}px, 0, 0); }
    to   { transform: translate3d(0, 0, 0); }
    `;
export const tabReturnRightFlat = keyframes`
    from { transform: translate3d(-${PEEK - 1}px, 0, 0); }
    to   { transform: translate3d(0, 0, 0); }
    `;

/* --- BumpOut bounce (starts off-screen, ends flush) --- */
export const bumpOutFromLeft = keyframes`
  0%   { transform: translate3d(-100%, 0, 0);                             animation-timing-function: cubic-bezier(.2,.8,.2,1); }
  60%  { transform: translate3d(calc(-100% + ${
      PEEK * 1.2
  }px), 0, 0);                animation-timing-function: cubic-bezier(.2,.7,.2,1); }
  78%  { transform: translate3d(calc(-100% + ${
      PEEK * 0.8
  }px), 0, 0);                animation-timing-function: cubic-bezier(.2,.65,.2,1); }
  88%  { transform: translate3d(calc(-100% + ${PEEK * 1.1}px), 0, 0); }
  100% { transform: translate3d(calc(-100% + ${PEEK}px), 0, 0); }
`;
export const bumpOutFromRight = keyframes`
  0%   { transform: translate3d(100%, 0, 0);                              animation-timing-function: cubic-bezier(.2,.8,.2,1); }
  60%  { transform: translate3d(calc(100% - ${
      PEEK * 1.2
  }px), 0, 0);                 animation-timing-function: cubic-bezier(.2,.7,.2,1); }
  78%  { transform: translate3d(calc(100% - ${
      PEEK * 0.8
  }px), 0, 0);                 animation-timing-function: cubic-bezier(.2,.65,.2,1); }
  88%  { transform: translate3d(calc(100% - ${PEEK * 1.1}px), 0, 0); }
  100% { transform: translate3d(calc(100% - ${PEEK}px), 0, 0); }
`;

/* BumpOut return */
export const bumpReturnLeft = keyframes`0%{transform: translate3d(calc(-100% + ${PEEK}px),0,0)} 100%{transform: translate3d(-100%,0,0)}`;
export const bumpReturnRight = keyframes`0%{transform: translate3d(calc(100% - ${PEEK}px),0,0)} 100%{transform: translate3d(100%,0,0)}`;

export const SlideOutContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100%;
    z-index: 1000;
    pointer-events: none; /* Allows clicking through the container when closed */
`;

export const SlideOutWrapper = styled.div<
    SlideOutWrapperProps & { tabBackgroundColor?: string; isMobile?: boolean }
>`
    position: absolute;
    ${({ openPanel = 'left', isOpen }) => {
        if (openPanel === 'left') {
            return `
                left: ${isOpen ? '0' : '-100%'};
                right: auto;
            `;
        } else {
            return `
                right: ${isOpen ? '0' : '-100%'};
                left: auto;
            `;
        }
    }}
    top: 0;
    height: 100%;
    width: ${({ isMobile }) => (isMobile ? '100%' : '90%')};
    z-index: 1001; /* Above the overlay */
    transition: ${({ openPanel = 'left' }) =>
        openPanel === 'left'
            ? 'left 0.3s ease-in-out'
            : 'right 0.3s ease-in-out'};
    display: flex;
    border-radius: ${({ isOpen, openPanel = 'left', isMobile }) =>
        isOpen && !isMobile
            ? openPanel === 'left'
                ? '0 8px 0 0'
                : '8px 0 0 0'
            : 'none'};
    box-shadow: ${({ isOpen, openPanel = 'left' }) =>
        isOpen
            ? openPanel === 'left'
                ? '3px 0 8px rgba(0, 0, 0, 0.25)'
                : '-3px 0 8px rgba(0, 0, 0, 0.25)'
            : 'none'};
    ${({ isOpen, tabBackgroundColor, openPanel = 'left', isMobile }) => {
        const borderColor = tabBackgroundColor || '#E47500';
        if (isOpen && !isMobile) {
            if (openPanel === 'left') {
                return `border-right: 10px solid ${borderColor};`;
            } else {
                return `border-left: 10px solid ${borderColor};`;
            }
        }
        return '';
    }}
    pointer-events: auto; /* Re-enable pointer events for the panel */

    @media (max-width: 600px) {
        max-width: 100%;
    }
`;

// Base tab style for both PanelTab and StaticTab
export const BaseTab = styled.div<
    TabHandleProps & { tabBackgroundColor?: string }
>`
    background: ${({ tabBackgroundColor }) => tabBackgroundColor || '#e47500'};
    border-radius: ${({ openPanel = 'left' }) =>
        openPanel === 'left' ? '0 8px 8px 0' : '8px 0 0 8px'};
    box-shadow: ${({ openPanel = 'left' }) =>
        openPanel === 'left'
            ? '3px 0 8px rgba(0, 0, 0, 0.25)'
            : '-3px 0 8px rgba(7, 5, 5, 0.25)'};
    clip-path: ${({ openPanel = 'left' }) =>
        openPanel === 'left'
            ? 'inset(-80px -15px -80px 0px)'
            : 'inset(-80px 0px -80px -15px)'};
    width: 40px;
    height: 180px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    pointer-events: auto;
    position: relative;
    overflow: visible;

    &::before,
    &::after {
        content: '';
        position: absolute;
        ${({ openPanel = 'left' }) =>
            openPanel === 'left' ? 'right: 0;' : 'left: 0;'}
        width: 52px;
        z-index: -1;
        ${({ openPanel = 'left' }) =>
            openPanel === 'right' ? 'transform: scaleX(-1);' : ''}
    }

    &::before {
        top: -60px;
        height: 70px;
        background: ${({ tabBackgroundColor }) =>
            tabBackgroundColor || '#e47500'};
        mask-image: url("data:image/svg+xml,%3Csvg width='52' height='70' viewBox='0 0 52 70' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M52 69.9187H8.59682e-10C8.59682e-10 69.9187 0.000244142 -13.5812 8.59682e-10 1.91875C-0.000175402 13.0547 26.8407 35.0302 41.9548 46.5219C48.1803 51.2553 52 58.5742 52 66.3949V69.9187Z' fill='%23E47500'/%3E%3C/svg%3E");
        mask-size: 52px 70px;
        mask-repeat: no-repeat;
        mask-position: ${({ openPanel = 'left' }) =>
            openPanel === 'left' ? 'right bottom' : 'left bottom'};
    }

    &::after {
        bottom: -60px;
        height: 71px;
        background: ${({ tabBackgroundColor }) =>
            tabBackgroundColor || '#e47500'};
        mask-image: url("data:image/svg+xml,%3Csvg width='52' height='71' viewBox='0 0 52 71' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M52 0.918663H8.59682e-10C8.59682e-10 0.918663 0.000244142 84.4186 8.59682e-10 68.9186C-0.000175402 57.7827 26.8407 35.8072 41.9548 24.3155C48.1803 19.5821 52 12.2632 52 4.44255V0.918663Z' fill='%23E47500'/%3E%3C/svg%3E");
        mask-size: 52px 71px;
        mask-repeat: no-repeat;
        mask-position: ${({ openPanel = 'left' }) =>
            openPanel === 'left' ? 'right top' : 'left top'};
    }
`;

// This tab is attached to the panel and shows when the panel is open
export const PanelTab = styled(BaseTab)`
    position: absolute;
    ${({ tabLocation = 'middle' }) => {
        if (tabLocation === 'top') {
            return 'top: 120px; transform: none;';
        } else if (tabLocation === 'bottom') {
            return 'bottom: 120px; top: auto; transform: none;';
        } else {
            return 'top: 50%; transform: translateY(-50%);';
        }
    }}
    ${
        ({ openPanel = 'left' }) =>
            openPanel === 'left'
                ? 'right: -49px; left: auto;' /* Position the tab outside the panel on the right */
                : 'left: -49px; right: auto;' /* Position the tab outside the panel on the left */
    }
    clip-path: ${({ openPanel = 'left' }) =>
        openPanel === 'left'
            ? 'inset(-80px -15px -80px 1px)'
            : 'inset(-80px 1px -80px -15px)'};
    margin-left: ${({ openPanel = 'left' }) =>
        openPanel === 'right' ? '1px' : '0'};
    margin-right: ${({ openPanel = 'left' }) =>
        openPanel === 'left' ? '1px' : '0'};
`;

// This tab is fixed and shows when the panel is closed
export const StaticTab = styled(BaseTab)`
    position: fixed;
    ${({ tabLocation = 'middle' }) => {
        if (tabLocation === 'top') {
            return 'top: 120px; transform: none;';
        } else if (tabLocation === 'bottom') {
            return 'bottom: 120px; top: auto; transform: none;';
        } else {
            return 'top: 50%; transform: translateY(-50%);';
        }
    }}
    ${({ openPanel = 'left' }) =>
        openPanel === 'left'
            ? 'left: 0; right: auto;'
            : 'right: 0; left: auto;'}
    z-index: 999; /* Below the panel but above other content */
    opacity: ${(props) => (props.isOpen ? 0 : 1)};
    transition: filter 0.2s, transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    will-change: transform;
    /* --- Intro bounce a few seconds after page load --- */
    .static-tab-intro & {
        transition: filter 0.2s; /* no transform transition while animating */

        animation-name: ${({ tabLocation = 'middle', openPanel = 'left' }) => {
                const mid = tabLocation === 'middle';
                return openPanel === 'left'
                    ? mid
                        ? springOutLeft
                        : springOutLeftFlat
                    : mid
                    ? springOutRight
                    : springOutRightFlat;
            }},
            ${({ tabLocation = 'middle', openPanel = 'left' }) => {
                const mid = tabLocation === 'middle';
                return openPanel === 'left'
                    ? mid
                        ? tabReturnLeftMid
                        : tabReturnLeftFlat
                    : mid
                    ? tabReturnRightMid
                    : tabReturnRightFlat;
            }};
        animation-duration: ${BOUNCE_MS}ms, ${RETURN_MS}ms;
        animation-delay: 0ms, ${BOUNCE_MS + PAUSE_MS}ms;
        animation-fill-mode: forwards, forwards;
        animation-iteration-count: 1, 1;
        /* one timing function per animation (segment easings live inside keyframes) */
        animation-timing-function: linear, cubic-bezier(0.4, 0, 0.2, 1);
    }
    /* Move StaticTab when parent has .static-tab-hovered */
    .static-tab-hovered & {
        ${({ tabLocation = 'middle', openPanel = 'left' }) => {
            if (tabLocation === 'top' || tabLocation === 'bottom') {
                return openPanel === 'left'
                    ? 'transform: translate3d(19px,0,0);'
                    : 'transform: translate3d(-19px,0,0);';
            } else {
                return openPanel === 'left'
                    ? 'transform: translate3d(19px,-50%,0);'
                    : 'transform: translate3d(-19px,-50%,0);';
            }
        }}
    }
`;

// Container for BumpOut and StaticTab, replaces inline-styled div in SlideOutTab.component.tsx
export const StaticTabContainer = styled.div<{
    openPanel: 'left' | 'right';
    isStaticTabHovered: boolean;
}>`
    position: fixed;
    top: 0;
    left: ${({ openPanel }) => (openPanel === 'left' ? 0 : 'auto')};
    right: ${({ openPanel }) => (openPanel === 'right' ? 0 : 'auto')};
    height: 100vh;
    z-index: 999;
    /* Optionally add hover class styles here if needed */
    &.static-tab-hovered {
        /* Add hover styles if any */
    }
`;

export const Label = styled.span<{
    openPanel?: 'left' | 'right';
    tabTextColor?: string;
    font?: 'inherit' | 'Arial' | 'Helvetica' | 'Times New Roman';
}>`
    transform: ${({ openPanel = 'left' }) =>
        openPanel === 'right' ? 'rotate(-90deg)' : 'rotate(90deg)'};
    transform-origin: center;
    color: ${({ tabTextColor }) => tabTextColor || '#fff'};
    font-family: ${({ font }) => {
        switch (font) {
            case 'Arial':
                return 'Arial, sans-serif';
            case 'Helvetica':
                return 'Helvetica, sans-serif';
            case 'Times New Roman':
                return '"Times New Roman", serif';
            case 'inherit':
                return 'inherit';
            default:
                return 'Oswald, sans-serif';
        }
    }};
    font-weight: medium;
    font-size: 20px;
    white-space: nowrap;
`;

// Mobile floating close button - only shows when open on mobile
export const MobileCloseButton = styled.button<{
    tabBackgroundColor?: string;
    tabTextColor?: string;
}>`
    position: fixed;
    top: 20px;
    right: 20px;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    border: none;
    background-color: ${({ tabBackgroundColor }) =>
        tabBackgroundColor || '#e47500'};
    color: ${({ tabTextColor }) => tabTextColor || '#fff'};
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    z-index: 1002;
    transition: all 0.2s ease-in-out;

    &:hover {
        transform: scale(1.05);
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
    }

    &:active {
        transform: scale(0.95);
    }

    /* Only show on mobile */
    @media (min-width: 768px) {
        display: none;
    }

    &::before {
        content: '✕';
        line-height: 1;
    }
`;

export const ContentContainer = styled.div`
    flex: 1;
    background-color: white;
    overflow: hidden;
    height: 100%;

    /* Force the widget content to be visible within the slide-out panel */
    & > div {
        position: relative !important;
        height: 100% !important;
    }
`;

export const Overlay = styled.div<OverlayProps>`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999; /* Below the panel but above other content */
    opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
    visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
    transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
    pointer-events: ${({ isOpen }) => (isOpen ? 'auto' : 'none')};
`;

// BumpOut: 10px wide, full height, positioned left or right of StaticTab, hidden by default, slides in on hover
export const BumpOut = styled.div<{
    openPanel?: 'left' | 'right';
    bumpOutColor?: string;
    imageBleedPx?: number;
    publicUrl?: string;
}>`
    position: fixed;
    top: 0;
    ${({ openPanel = 'left' }) =>
        openPanel === 'left'
            ? 'left: 0; right: auto;'
            : 'right: 0; left: auto;'}
    width: 20px;
    height: 100vh;
    background-color: ${({ bumpOutColor }) => bumpOutColor || '#e47500'};
    z-index: 998;
    padding: ${({ openPanel = 'left' }) =>
        openPanel === 'left' ? '0 10px 0 0' : '0 0 0 10px'};
    border-radius: ${({ openPanel = 'left' }) =>
        openPanel === 'left' ? '0 8px 0 0' : '8px 0 0 0'};
    transform: ${({ openPanel = 'left' }) =>
        openPanel === 'left' ? 'translateX(-100%)' : 'translateX(100%)'};
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    pointer-events: none;
    overflow: visible;
    isolation: isolate;
    will-change: transform;
    &::before {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;

        /* how far to overflow */
        ${({ openPanel = 'left', imageBleedPx = 22 }) =>
            openPanel === 'left'
                ? `
        /* LEFT side: leave a 10px gap on the inside (right), bleed outward on the left */
        right: 10px;        /* gap from page edge */
        left: -${imageBleedPx}px;         /* overflow off-screen */
        background-position: right center;
      `
                : `
        /* RIGHT side: leave a 10px gap on the inside (left), bleed outward on the right */
        left: 10px;         /* gap from page edge */
        right: -${imageBleedPx}px;        /* overflow off-screen */
        background-position: left center;
      `}

        background-image: ${({ publicUrl }) =>
            publicUrl ? `url('${publicUrl}/mapSliver.png')` : 'none'};
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
    }

    /* --- Intro bounce (peek in then hide) --- */
    .static-tab-intro & {
        transition: none;
        border: none;
        animation-name: ${({ openPanel = 'left' }) =>
                openPanel === 'left' ? bumpOutFromLeft : bumpOutFromRight},
            ${({ openPanel = 'left' }) =>
                openPanel === 'left' ? bumpReturnLeft : bumpReturnRight};
        animation-duration: ${BOUNCE_MS}ms, ${RETURN_MS}ms;
        animation-delay: 0ms, ${BOUNCE_MS + PAUSE_MS}ms;
        animation-fill-mode: forwards, forwards;
        animation-iteration-count: 1, 1;
        animation-timing-function: linear, cubic-bezier(0.4, 0, 0.2, 1);
    }
    /* Show when StaticTab is hovered */
    .static-tab-hovered & {
        transform: translateX(0);
    }
`;
